import { createSelector } from "reselect";
import { RootState } from "src/store/rootReducer";

const selectChecklistTasksState = (state: RootState) => state.checklistTasks;

export const selectChecklistTasks = createSelector(selectChecklistTasksState, (state) =>
  state.ids.map((id) => state.entities[id]).filter(Boolean)
);

export const selectChecklistTaskById = (connectionId?: number | null) =>
  createSelector(selectChecklistTasksState, (state) => {
    if (!connectionId) return null;
    return state.entities[connectionId] ?? null;
  });

export const selectChecklistTasksStatus = createSelector(selectChecklistTasksState, (state) => state.status);

export const selectChecklistShiftItems = createSelector(selectChecklistTasksState, (state) => state.shiftItems);

export const selectChecklistShiftStatus = createSelector(selectChecklistTasksState, (state) => state.shiftStatus);

export const selectChecklistShiftMutationStatus = createSelector(
  selectChecklistTasksState,
  (state) => state.shiftMutationStatus
);

export const selectChecklistSelectedTaskId = createSelector(selectChecklistTasksState, (state) => state.selectedId);

export const selectChecklistTaskSelectedStatus = createSelector(
  selectChecklistTasksState,
  (state) => state.selectedStatus
);

export const selectChecklistPeriodDate = createSelector(selectChecklistTasksState, (state) => state.periodDate);
